@font-face {
  font-family: "PM Payments Inter";
  src: url("@fontsource-variable/inter/files/inter-latin-wght-normal.woff2")
    format("woff2");
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}

.shell,
.dialog {
  --pm-font-family: "PM Payments Inter", sans-serif;
  --pm-text-secondary: var(--pm-text-secondary-neutral);
  font-family: var(--pm-font-family);
}

.shell {
  min-height: 100dvh;
  background: var(--pm-html-background);
}

.page {
  background: var(--pm-html-background);
  color: var(--pm-text-primary);
  min-height: calc(100dvh - 2.875rem);
  padding-bottom: 7rem;
}

.header {
  background: var(--pm-surface);
  border-bottom: 1px solid var(--pm-border-neutral);
  padding: 1.0625rem 1rem 1.125rem;
}

.headerContent,
.content {
  margin: 0 auto;
  max-width: 37.5rem;
}

.headingRow,
.heading {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
}

.headingRow {
  justify-content: space-between;

  > :global(.MuiButton-root) {
    line-height: 1.0625rem;
    min-height: 0;
    padding: 0;
  }
}

.heading {
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0.25rem 0.625rem;

  h1 {
    color: var(--pm-text-primary);
    font-family: inherit;
    font-size: 1.4375rem;
    font-weight: 600;
    letter-spacing: -0.035em;
    line-height: 1.75rem;
    margin: 0;
    word-break: normal;
  }

  > span {
    color: var(--pm-text-secondary);
    font-size: 0.875rem;
    letter-spacing: -0.03em;
  }
}

.headerContent .backButton {
  color: var(--pm-blue);
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.5rem;
  justify-content: flex-start;
  margin: 0 0 0.625rem;
  min-width: 0;
  min-height: 1.5rem;
  padding: 0;
  text-transform: none;

  svg {
    fill: currentColor;
    transform: rotate(90deg);
  }
}

.content {
  padding: 1rem 1rem 0;
}

.branding {
  border-top: 1px solid var(--pm-border);
  margin-top: 1.25rem;
  padding-top: 1.625rem;

  > div {
    display: flex;
    justify-content: center;
    padding: 0;
    color: var(--pm-text-primary);
  }
}

.sectionTitle {
  color: var(--pm-text-secondary);
  font-size: 0.8125rem;
  font-weight: 400;
  letter-spacing: 0.08em;
  margin: 1.25rem 0 0.375rem;
  text-transform: uppercase;
}

.page .sectionTitle {
  font-size: 0.8125rem !important;
  font-weight: 400 !important;
  word-break: normal;
}

.card,
.panel,
.settings {
  background: var(--pm-surface);
  border-radius: 0.75rem;
  box-shadow: 0 1px 1px var(--pm-box-shadow);
  margin-bottom: 0.625rem;
  padding: 1.25rem 1.125rem;
}

.settings > div:last-child {
  margin-bottom: 0;
}

.content [data-test-class="accordion-list"] {
  margin-bottom: 0.625rem;
}

:global(#root) {
  .page {
    .card {
      border: 0;
      border-radius: 0.75rem;
      padding: 0;

      > [data-test-class="accordion-head"] {
        min-height: 3.875rem;
        height: auto;
        box-sizing: border-box;
        padding: 1.125rem 2.75rem 1.125rem 1.125rem;
        gap: 0.5rem;

        > svg {
          top: 50%;
          transform: translateY(-50%);
        }
      }

      &[data-test-open="true"] > [data-test-class="accordion-head"] > svg {
        transform: translateY(-50%) rotate(180deg);
      }
    }

    :global(.MuiButton-root) {
      font-family: inherit;
      text-transform: none;
    }

    :global(.MuiButton-root)[id="make-payment-button"],
    :global(.MuiButton-root)[id="pay-now-button"],
    :global(.MuiButton-root)[data-test-class="enable-autopay-button"],
    :global(.MuiButton-root)[id="back-to-payments-button"] {
      background: var(--pm-blue-NEW);
      border: 0;
      border-radius: 0.75rem;
      font-size: 1.0625rem;
      font-weight: 600;
      letter-spacing: -0.02em;
      line-height: 1.3125rem;
      margin-top: 1.25rem;
      min-height: 2.875rem;
      height: auto;
      padding: 0.6875rem 0.625rem 0.875rem;

      &:disabled {
        background: var(--pm-border);
        border-color: var(--pm-border);
      }
    }

    :global(.invoice-checkbox) {
      position: relative;
      z-index: 2;
      height: 1rem;
      padding: 0;
      width: 1rem;

      > svg {
        height: calc(1rem * 24 / 18);
        width: calc(1rem * 24 / 18);
      }
    }

    label:has(:global(.invoice-checkbox)) {
      margin: 0;
    }
  }
}

.shell > [data-test-class="main-header"] {
  background: var(--pm-surface) !important;
  border-color: var(--pm-border-light);

  :global(#back-button) {
    display: none;
  }
}

.dialog:global(.MuiPaper-root) {
  background: var(--pm-surface);
  color: var(--pm-text-primary);
  border-radius: 1.625rem;
  width: 31.25rem;
  max-width: calc(100vw - 2rem);
  max-height: calc(100dvh - 2rem);

  :global(.MuiFormControl-root),
  :global(.MuiInputBase-root) {
    min-width: 0;
    font-family: inherit;
  }

  :global(.MuiOutlinedInput-root) {
    min-height: 2.625rem;
  }

  :global(.MuiInputBase-input) {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  :global(.MuiButton-root) {
    font-family: inherit;
    text-transform: none;
  }
}

.dialog .dialogTitle:global(.MuiDialogTitle-root) {
  color: var(--pm-text-primary);
  font-family: inherit;
  font-size: 1.4375rem !important;
  font-weight: 600 !important;
  letter-spacing: -0.035em;
  line-height: 1.75rem;
  padding: 1rem !important;
}

.dialog .dialogContent {
  padding: 0 1rem 1rem !important;
  overflow-y: auto !important;
}

:global(#root) .dialog .dialogActions {
  border-top: 1px solid var(--pm-border-light);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.625rem;
  padding: 0.5625rem 1rem 1rem !important;

  > button {
    border-radius: 0.75rem;
    flex: 1;
    font-size: 1.0625rem;
    font-weight: 600;
    line-height: 1.3125rem;
    margin: 0 !important;
    min-height: 2.9375rem;
    min-width: 0;
    padding: 0.75rem 0.625rem;
  }

  > button:last-child:not(:disabled) {
    background: var(--pm-blue-NEW);
    border-color: var(--pm-blue-NEW);
    color: var(--pm-text-filled-button);
  }
}

.securityMessage {
  align-items: center;
  color: var(--pm-text-secondary);
  display: flex;
  font-size: 0.9375rem;
  gap: 0.625rem;
  margin-top: 1rem;
}

.securityIcon {
  color: var(--pm-grey8);
  display: inline-flex;
  flex-shrink: 0;
  height: 20px;
  width: 20px;
}

:global(.dark),
:global(.theme-dark1) {
  .securityIcon {
    color: var(--D9);
  }
}

.cardFields {
  min-width: 0;
  padding-top: 0.5625rem;
}

.billingTitle {
  color: var(--pm-text-primary);
  font-size: 1.125rem;
  font-weight: 500;
  margin: 0 0 1rem;
}

.billingFields {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.625rem;

  > div {
    min-width: 0;
  }

  > div:nth-child(-n + 2) {
    grid-column: span 2;
  }
}

.successIcon {
  align-items: center;
  background: color-mix(in srgb, var(--pm-blue-NEW) 15%, transparent);
  box-sizing: content-box;
  border-radius: 1.25rem;
  display: flex;
  color: var(--pm-blue-lighter);
  height: 39.0244px;
  justify-content: center;
  padding: 0.75rem;
  margin-bottom: 1.9375rem;
  width: 39.0244px;

  > svg {
    height: 39.0244px;
    width: 39.0244px;
  }
}

.success {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 0.625rem;

  > h1 {
    font-family: inherit;
    font-size: 1.4375rem;
    font-weight: 600;
    line-height: 1.75rem;
    margin: 0 0 1.9375rem;
    text-align: center;
  }

  > button {
    width: 100%;
  }
}

.processing {
  font-family: "PM Payments Inter", sans-serif;

  [data-test-class="loading-spinner"] {
    > svg {
      margin-bottom: 1.375rem;
    }

    > h1 {
      font-family: inherit;
      font-size: 1.4375rem;
      font-weight: 600;
      line-height: 1.75rem;
    }
  }
}

.cardFields > div:has(input[name="cvv"]) {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.625rem;

  > div:first-child {
    max-width: none;
    margin-right: 0;
  }
}

.dialog :global(.MuiFilledInput-root) {
  background: transparent;
  border: 1px solid var(--pm-border);
  border-radius: 0.25rem;

  &::before,
  &::after {
    display: none;
  }
}

.dialog
  :global(.MuiDialogActions-root)
  > :global(.MuiButton-root):not([data-test-class]),
.dialog
  :global(.MuiDialogActions-root)
  > [data-test-class="use-bank-account-button"],
.dialog
  :global(.MuiDialogActions-root)
  > [data-test-class="use-credit-card-button"] {
  flex-basis: 100%;
}

:global(.dark),
:global(.theme-dark1) {
  .shell,
  .dialog {
    --pm-surface: var(--D3);
    --pm-text-primary: var(--D16);
    --pm-text-secondary: var(--D12);
    --pm-html-background: var(--D2);
    --pm-border-neutral: var(--D6);
    --pm-border: var(--D7);
    --pm-border-light: var(--D6);
    --pm-blue: var(--pm-blue-lighter);
  }
}

@media (min-width: 1025px) {
  .page {
    padding-top: 70px;
    min-height: 100dvh;
    box-sizing: border-box;
    padding-bottom: 2.5rem;
  }

  .content {
    padding-left: 0;
    padding-right: 0;
  }

  .shell > [data-test-class="main-footer"] {
    display: none;
  }

  .shell > [data-test-class="main-header"] {
    box-sizing: border-box;
    height: 70px;
    justify-content: flex-end;

    nav {
      left: 50%;
      max-width: 37.5rem;
      position: absolute;
      transform: translateX(-50%);
      width: 100%;

      > ul {
        justify-content: space-between;
        width: 100%;
      }

      li a {
        font-family: inherit;
        font-size: 1.0625rem;
        font-weight: 500;
        padding: 0.625rem 0;
      }
    }
  }
}

@media (max-width: 600px) {
  .headingRow {
    align-items: flex-start;
  }

  .heading {
    gap: 0.125rem;
    flex-direction: column;
  }

  .headerContent .backButton {
    display: none;
  }

  .shell > [data-test-class="main-header"] :global(#back-button) {
    display: inline-flex;
    color: var(--pm-blue-vivid);
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.5rem;
    min-width: 0;
    padding: 0;
    text-transform: none;

    :global(.dark) &,
    :global(.theme-dark1) & {
      color: var(--pm-blue-bright);
    }

    svg {
      height: 24px;
      width: 24px;
      margin-right: -5px;

      path {
        color: inherit;
        fill: currentColor;
      }
    }
  }

  .dialog:global(.MuiPaper-root) {
    border-radius: 1.625rem 1.625rem 0 0;
    margin: 0;
    max-width: 100%;
    max-height: calc(100dvh - 1rem) !important;
    width: 100%;
  }

  :global(#root) .dialog .dialogActions {
    padding-bottom: max(0.625rem, env(safe-area-inset-bottom)) !important;
  }

  .billingFields {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    > div:nth-child(-n + 2) {
      grid-column: span 1;
    }
  }
}
